import VueRouter, { Route } from 'vue-router';
import { Store } from 'vuex';
import { loadLocaleAsync } from '@/i18n';
import { localeCodeFromRoute } from '@/i18n/helpers';
import IRootState from '@/store/types/IRootState';
import { config } from '@/config';

export function attachGuards(router: VueRouter, store: Store<IRootState>): void {
  router.beforeEach((to: Route, from: Route, next: (callback?: any) => void) => {
    if (to) {
      const localeCode = localeCodeFromRoute(to);
      if (localeCode !== '' && localeCode !== null) {
        if (localeCode !== store.state.app.locale) {
          loadLocaleAsync(localeCode).then(() => next());
          store.dispatch('app/changeLocale', localeCode);
        } else {
          next();
        }
      } else {
        store.dispatch('app/changeLocale', config.i18n.defaultLocale);
        next();
      }
    } else {
      next();
    }
  });
}
